/* global jQuery */

/**
 * Base file to maintain all ajax-forms operations.
 * Contain default validation behaviour.
 * If need custom one, please use:
 * - jquery.shopgate.ajax-forms-checkout - for checkout related validations
 * - jquery.shopgate.ajax-forms-notification - for generic_notification system forms (apps only)
 * - ... or create new one if needed
 *
 */
(function ($) {
  /* eslint-disable no-param-reassign, no-underscore-dangle, require-jsdoc, valid-jsdoc, consistent-return, no-use-before-define */
  $.fn.shopgateAjaxFormSubmit = function (options) {
    const defaults = {};

    options = options || {};
    options = $.extend({}, defaults, options);

    return this.each(function () {
      const currentForm = $(this);
      let action = currentForm.attr('action');
      let submitButton = currentForm.find('input[type=submit]');
      const submitDisabled = false;
      const isAjaxReloadForm = currentForm.hasClass('ajax-reload');
      const useWaitingIndicator = currentForm.data('useWaitingIndicator');
      const postRegex = /_method=POST&/i;

      $(this).data('shopgateAjaxFormSubmit', this);

      toggleSubmitDisabled(false);

      if (submitButton.length == 0) {
        submitButton = currentForm.find('button[type=submit]');
      }

      currentForm.unbind('submit').submit(function (e) {
        // Abort the real submit
        e.preventDefault();
                // Updating the action
        action = $(this).attr('action');
        /* Blur input fields after submitting the form to close the keypad */
        currentForm.find('input').blur();
        if (currentForm.data('submitDisabled')) {
          return false;
        }

        if (currentForm.data('submitOverridden')) {
          return;
        }

        if (action) {
          if (isAjaxReloadForm) {
            let serializedData = currentForm.serialize();

            if (serializedData && !postRegex.test(serializedData)) {
              serializedData = `_method=POST&${serializedData}`;
            }

            $.shopgate.ajaxContentUpdate({
              url: action,
              data: serializedData,
              beforeSend: _beforeSend,
              complete: _complete,
              error: _error,
              success: _success,
            });
          } else {
            $.shopgate.ajax({
              url: action,
              data: currentForm.serialize(),
              beforeSend: _beforeSend,
              complete: _complete,
              error: _error,
              success: _success,
            });
          }
        }
      });

      function toggleSubmitDisabled(disabled) {
        currentForm.data('submitDisabled', !!disabled);
      }

      function _complete() {
        toggleSubmitDisabled(false);
        submitButton.prop('disabled', false);
        submitButton.removeClass('disabled loading');
        if (isAjaxReloadForm || useWaitingIndicator) {
          $(document).trigger('shopgateFramework.waitingIndicator.hide');
        }
      }

      function _beforeSend() {
        toggleSubmitDisabled(true);
        submitButton.prop('disabled', true);
        submitButton.addClass('disabled loading');

        if (isAjaxReloadForm || useWaitingIndicator) {
          $(document).trigger('shopgateFramework.waitingIndicator.show');
        }
      }

      function _error(jqXHR, textStatus, errorThrown) {}

      function _success(data) {
        let targetForm = currentForm;

        /**
         * When the ajaxContentUpdate plugin is used to submit the form, the site content is already
         * completely replaced when the success method is invoked. The form is still available in
         * memory, but it will not receive events anymore.
         * The following block tries to find the replacement of the form, and to send the necessary
         * events to the new form instance.
         */
        const formIsMounted = $(document).find(currentForm).length !== 0;
        if (!formIsMounted) {
          const id = currentForm.attr('id');
          const selector = `form[action="${action}"]${id ? `#${id}` : ''}`;
          targetForm = $(selector);
        }

        // Check if the validation errors attribute is present in the response object
        if (typeof data.validationErrors === 'object' && data.validationErrors !== null) {
          _processValidationErrors(targetForm, data.validationErrors);
        } else {
          targetForm.trigger('sgFramework.forms.validation.reset');
        }

        delete (data.validationErrors);
        delete (data.shopBackLink);

        targetForm.trigger('shopgateFramework.forms.dataUpdate', [data]);
        $(document).trigger('shopgateFramework.forms.dataUpdate', [data]);
      }
    });

    /**
     * Processes the validation errors within an ajax-form-submit response
     * @param {object} errorsFromAjaxResponse
     */
    function _processValidationErrors(currentForm, errorsFromAjaxResponse) {
      // Reset the current errors - we don't know if we get some new in this response
      currentForm.trigger('sgFramework.forms.validation.reset');

      if (typeof errorsFromAjaxResponse === 'undefined' || !errorsFromAjaxResponse) { return false; }

      let validationErrorList = [];

      // Iterate through the models
      $.each(errorsFromAjaxResponse, (model, errors) => {
        let isComplex = false;

        // Check if we got errors for a complex form ( > 1 record in one db-model)
        $.each(errors, (key, value) => {
          if ($.isNumeric(key) || $.isPlainObject(value)) {
            isComplex = true;
          }

          return false;
        });

        let errorsPerModel = [];

        if ($.isArray(errors) || isComplex) {
          let errorsPerRow = [];

          $.each(errors, (recordIndex, errorObject) => {
            const singleResult = _processValidationErrorObject(model, errorObject, recordIndex);
            errorsPerRow = $.merge(errorsPerRow, singleResult);
          });

          errorsPerModel = $.merge(errorsPerModel, errorsPerRow);
        } else {
          errorsPerModel = _processValidationErrorObject(model, errors);
        }

        validationErrorList = $.merge(validationErrorList, errorsPerModel);
      });

      /**
       * Seems that we've processes all the errors. so we propagate them to the form so that another
       * script can create the needed markup to show them to the user
       */
      currentForm.trigger('sgFramework.forms.validation.set', [validationErrorList]);

      /**
       * Creates a list of name-tag values and validation error texts
       */
      function _processValidationErrorObject(model, errorObject, recordIndex) {
        const errorList = [];

        $.each(errorObject, (field, errorText) => {
          let elementName;

          if (typeof recordIndex === 'undefined') {
            elementName = `data[${model}][${field}]`;
          } else {
            elementName = `data[${model}][${recordIndex}][${field}]`;
          }

          errorList.push({
            element: elementName,
            texts: errorText,
          });
        });

        return errorList;
      }
    }
  };

  $.fn.shopgateAjaxFormValidationDefault = function (options) {
    const defaults = {};

    options = options || {};
    options = $.extend({}, defaults, options);

    return this.each(function () {
      const that = $(this);

      that.unbind('sgFramework.forms.validation.reset').bind('sgFramework.forms.validation.reset', (e) => {
        that.find('.form-group').removeClass('has-error');
        that.find('.help-block').remove();
        that.find('[aria-invalid]').attr('aria-invalid', false);
      }).unbind('sgFramework.forms.validation.set').bind('sgFramework.forms.validation.set', (e, errors, preventScrolling) => {
        if (errors) {
          $.each(errors, (index, error) => {
            if (error.element) {
              let elementName = error.element;

              // Remove last char ']' for state ids
              if (elementName.indexOf('state_id') !== -1) {
                elementName = elementName.slice(0, -1);
              }

              const input = that.find(`[name^='${elementName}']`);
              const formGroup = input.closest('.form-group');

              formGroup.addClass('has-error');

              if (error.texts[0]) {
                const messages = error.texts.join('<br>');

                $(`<span class="help-block" aria-hidden="true" id="${elementName}_error" />`)
                  .html(messages)
                  .appendTo(formGroup);
              }

              if (input.attr('aria-invalid') !== 'undefined') {
                input.attr({
                  'aria-invalid': true,
                  'aria-describedby': `${elementName}_error`,
                });
              }
            }
          });

          const firstError = that.find('.has-error:visible').first();

          if (!preventScrolling && firstError.length > 0) {
            let scrollHeight = firstError.offset().top - (parseInt(firstError.css('marginTop'), 10) / 2);
            const scrollOffset = firstError.data('scrollOffset');

            if (scrollOffset) {
              scrollHeight -= scrollOffset;
            }

            if (parseInt($('body').css('paddingTop'), 10) > 0) {
              scrollHeight -= parseInt($('body').css('paddingTop'), 10);
            }
            $('html,body').animate({ scrollTop: scrollHeight }, 'slow');
          }
        }
      });
    });
  };

  $.fn.watchFormChanges = function () {
    return this.each(function () {
      $.data(this, 'formHash', $(this).serialize());
    });
  };

  $.fn.formHasChanged = function () {
    let hasChanged = false;

    this.each(function () {
      const formHash = $.data(this, 'formHash');

      if (formHash != null && formHash !== $(this).serialize()) {
        hasChanged = true;
        return false;
      }
    });

    return hasChanged;
  };
}(jQuery));



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-ajax-forms.js